class ProductAccordion {
  constructor() {
    this.triggers = document.querySelectorAll('.accordion-trigger');
    this.init();
  }

  init() {
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', !isExpanded);
        
        // Cerrar otros acordeones abiertos
        if (!isExpanded) {
          this.triggers.forEach(otherTrigger => {
            if (otherTrigger !== trigger && otherTrigger.getAttribute('aria-expanded') === 'true') {
              otherTrigger.setAttribute('aria-expanded', 'false');
            }
          });
        }
      });
    });
  }
}

/**
 * Aplica el efecto foil a las imágenes del producto cuando se selecciona una variante foil
 */
class ProductFoilEffect {
  constructor() {
    this.mediaContainers = document.querySelectorAll('.product-media-container');
    this.init();
  }

  init() {
    console.log('ProductFoilEffect: Initializing');
    
    // Esperar a que variant-selects esté inicializado
    setTimeout(() => {
      // Aplicar efecto foil inicial si la variante actual es foil
      this.checkInitialVariant();
    }, 300);

    // Escuchar cambios de variante
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      console.log('ProductFoilEffect: Subscribing to variantChange event');
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        console.log('ProductFoilEffect: variantChange event received', event);
        if (event && event.data && event.data.variant) {
          this.handleVariantChange(event.data.variant);
        } else {
          console.warn('ProductFoilEffect: Event data missing variant', event);
        }
      });
    } else {
      console.warn('ProductFoilEffect: subscribe or PUB_SUB_EVENTS not available');
    }
  }

  /**
   * Verifica si la variante inicial es foil
   */
  checkInitialVariant() {
    const variantInput = document.querySelector('input[name="id"]');
    if (!variantInput || !variantInput.value) {
      console.log('ProductFoilEffect: No variant input found');
      return;
    }

    const variantId = parseInt(variantInput.value);
    console.log('ProductFoilEffect: Checking initial variant', variantId);

    // Buscar información de la variante en el DOM
    const variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
      // Intentar obtener currentVariant
      if (variantSelects.currentVariant) {
        console.log('ProductFoilEffect: Found currentVariant', variantSelects.currentVariant);
        this.handleVariantChange(variantSelects.currentVariant);
        return;
      }
      
      // Intentar obtener variantData y buscar la variante
      try {
        const variantData = variantSelects.getVariantData();
        if (variantData && Array.isArray(variantData)) {
          const currentVariant = variantData.find(v => v.id === variantId);
          if (currentVariant) {
            console.log('ProductFoilEffect: Found variant in data', currentVariant);
            this.handleVariantChange(currentVariant);
            return;
          }
        }
      } catch (e) {
        console.error('ProductFoilEffect: Error getting variant data', e);
      }
      
      // Fallback: buscar en script tag dentro de variant-selects
      const variantDataScript = variantSelects.querySelector('script[type="application/json"]');
      if (variantDataScript) {
        try {
          const variantData = JSON.parse(variantDataScript.textContent);
          const currentVariant = variantData.find(v => v.id === variantId);
          if (currentVariant) {
            console.log('ProductFoilEffect: Found variant in script', currentVariant);
            this.handleVariantChange(currentVariant);
            return;
          }
        } catch (e) {
          console.error('ProductFoilEffect: Error parsing variant script', e);
        }
      }
    }
    
    console.log('ProductFoilEffect: Could not find variant data');
  }

  /**
   * Maneja el cambio de variante
   */
  handleVariantChange(variant) {
    if (!variant) {
      console.log('ProductFoilEffect: No variant provided');
      return;
    }

    console.log('ProductFoilEffect: Handling variant change', variant);
    const isFoil = this.isVariantFoil(variant);
    console.log('ProductFoilEffect: Is foil?', isFoil);
    this.toggleFoilEffect(isFoil);
  }

  /**
   * Verifica si una variante es foil
   */
  isVariantFoil(variant) {
    if (!variant) {
      console.log('ProductFoilEffect: isVariantFoil - no variant provided');
      return false;
    }

    console.log('ProductFoilEffect: Checking if variant is foil', variant);

    // Verificar en el título de la variante
    const variantTitle = variant.title ? variant.title.toLowerCase() : '';
    console.log('ProductFoilEffect: Variant title:', variantTitle);
    
    if (variantTitle.includes('foil') && !variantTitle.includes('non-foil')) {
      console.log('ProductFoilEffect: Variant is foil (detected in title)');
      return true;
    }

    // Verificar en las opciones
    if (variant.options && Array.isArray(variant.options)) {
      console.log('ProductFoilEffect: Checking options:', variant.options);
      for (let option of variant.options) {
        const optionLower = option ? option.toLowerCase() : '';
        if (optionLower.includes('foil') && !optionLower.includes('non-foil')) {
          console.log('ProductFoilEffect: Variant is foil (detected in option:', option, ')');
          return true;
        }
      }
    }

    // Verificar en option1, option2, option3 si existen
    for (let optKey of ['option1', 'option2', 'option3']) {
      if (variant[optKey]) {
        const optionValue = variant[optKey].toLowerCase();
        if (optionValue.includes('foil') && !optionValue.includes('non-foil')) {
          console.log('ProductFoilEffect: Variant is foil (detected in', optKey, ':', variant[optKey], ')');
          return true;
        }
      }
    }

    console.log('ProductFoilEffect: Variant is NOT foil');
    return false;
  }

  /**
   * Aplica o quita el efecto foil
   */
  toggleFoilEffect(apply) {
    // Buscar todos los contenedores de medios del producto
    const mediaContainers = document.querySelectorAll('.product-media-container');
    
    console.log('ProductFoilEffect: Toggling foil effect', apply, 'on', mediaContainers.length, 'containers');
    
    if (mediaContainers.length === 0) {
      console.warn('ProductFoilEffect: No media containers found');
    }
    
    mediaContainers.forEach((container, index) => {
      if (apply) {
        // Remover la clase primero si existe para reiniciar la animación
        container.classList.remove('product__media--foil');
        
        // Forzar reflow para que la animación se reinicie
        void container.offsetWidth;
        
        // Agregar la clase para activar la animación
        container.classList.add('product__media--foil');
        console.log(`ProductFoilEffect: Added foil class to container ${index}`);
        
        // Buscar el contenedor .product__media dentro del container para agregar el overlay ahí
        const productMedia = container.querySelector('.product__media');
        const targetContainer = productMedia || container;
        
        // Asegurar que existe el overlay foil
        let foilOverlay = targetContainer.querySelector('.foil-overlay');
        if (!foilOverlay) {
          foilOverlay = document.createElement('div');
          foilOverlay.className = 'foil-overlay';
          targetContainer.appendChild(foilOverlay);
          console.log(`ProductFoilEffect: Added foil overlay to container ${index}`, targetContainer);
        }
        
        // Activar fade-in mientras la carta está girando (antes de que pare)
        setTimeout(() => {
          foilOverlay.classList.add('foil-overlay--visible');
        }, 300); // 300ms = mientras todavía está girando
      } else {
        container.classList.remove('product__media--foil');
        console.log(`ProductFoilEffect: Removed foil class from container ${index}`);
        
        // Remover el overlay foil si existe (buscar en todo el container)
        const foilOverlay = container.querySelector('.foil-overlay');
        if (foilOverlay) {
          // Fade out antes de remover
          foilOverlay.classList.remove('foil-overlay--visible');
          setTimeout(() => {
            foilOverlay.remove();
            console.log(`ProductFoilEffect: Removed foil overlay from container ${index}`);
          }, 600); // Esperar a que termine la transición
        }
      }
    });
  }
}

// Inicializar cuando el DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initializeProductFeatures();
  });
} else {
  // DOM ya está listo
  initializeProductFeatures();
}

function initializeProductFeatures() {
  new ProductAccordion();
  
  // Inicializar efecto foil solo en páginas de producto
  if (document.querySelector('.product')) {
    console.log('ProductFoilEffect: Product page detected, initializing...');
    new ProductFoilEffect();
  } else {
    console.log('ProductFoilEffect: Not a product page, skipping initialization');
  }
} 